"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawContents = void 0;
const helpers_1 = require("../helpers");
function drawImageContent(context, content, assetCache) {
    const image = assetCache.getImage(content.image.url);
    // Image has not loaded yet.
    if (!(0, helpers_1.isValidImage)(image)) {
        (0, helpers_1.drawLoadingAnimation)(context, content);
        return;
    }
    const imageScale = image.width / content.image.width;
    const dimensionFlipped = content.image.rotation % 2 === 1;
    context.save();
    context.translate(content.x, content.y);
    if (content.image.rotation) {
        const centerOffsetWidth = content.width / 2;
        const centerOffsetHeight = content.height / 2;
        context.translate(centerOffsetWidth, centerOffsetHeight);
        context.rotate(-content.image.rotation * Math.PI / 2);
        context.translate(dimensionFlipped ? -centerOffsetHeight : -centerOffsetWidth, dimensionFlipped ? -centerOffsetWidth : -centerOffsetHeight);
    }
    (0, helpers_1.drawImage)(context, image, content.image.clippingMask.x * imageScale, content.image.clippingMask.y * imageScale, content.image.clippingMask.width * imageScale, content.image.clippingMask.height * imageScale, 0, 0, dimensionFlipped ? content.height : content.width, dimensionFlipped ? content.width : content.height);
    context.restore();
}
function drawContents(context, { contents }, assetCache) {
    contents.forEach(content => {
        switch (content.type) {
            case 'image': {
                drawImageContent(context, content, assetCache);
                break;
            }
        }
    });
}
exports.drawContents = drawContents;
